const UNNAMED_ITEM_LABEL = 'Item sem nome';

export const DIRECTORY_ITEM_LABEL_SEPARATOR = ' - ';

export interface DirectoryItemLabelParts {
  /** Rótulo composto, usado em ordenação, modais e toasts. */
  label: string;
  /** Prefixo isolado, ausente quando o item não tem prefixo. */
  prefix?: string;
  /** Título isolado, ausente quando o item só tem prefixo ou não tem identificação nenhuma. */
  title?: string;
}

/**
 * Prefixo e título de um item vinculado, separados como a API os devolve, mais o rótulo composto
 * no mesmo formato que o backend usa em `formatDocumentLabel`. A árvore renderiza as partes; quem
 * precisa de uma string só usa `label`. Nada reparseia o rótulo, então nome com " - " no meio
 * ("Ata - Reunião 12") continua inteiro.
 *
 * Quando falta um dos dois, o que sobrou é o rótulo — cair direto em "Item sem nome" esconde a
 * única identificação que o item tem. Nunca devolve string vazia: um nome vazio renderizava a
 * linha só com o ícone.
 */
export function resolveDirectoryItemLabelParts(
  name: string | null | undefined,
  prefix: string | null | undefined
): DirectoryItemLabelParts {
  const title = name?.trim() ? name.trim() : undefined;
  const trimmedPrefix = prefix?.trim() ? prefix.trim() : undefined;

  if (trimmedPrefix && title) {
    return {
      label: `${trimmedPrefix}${DIRECTORY_ITEM_LABEL_SEPARATOR}${title}`,
      prefix: trimmedPrefix,
      title,
    };
  }

  if (title) {
    return { label: title, title };
  }

  if (trimmedPrefix) {
    return { label: trimmedPrefix, prefix: trimmedPrefix };
  }

  return { label: UNNAMED_ITEM_LABEL };
}

export function resolveDirectoryItemLabel(
  name: string | null | undefined,
  prefix: string | null | undefined
): string {
  return resolveDirectoryItemLabelParts(name, prefix).label;
}
